import { Grid } from '@material-ui/core'
import styled from 'styled-components'

export const GridFields = styled(Grid)`
  display: flex;
  margin: -16px;
  width: calc(100% + 24px);
  flex-direction: row;
  .Mui-disabled {
    color: ${({ theme }) => theme.colors.gray.brighten()};
    border-color: ${({ theme }) => theme.colors.gray.brighten()};
    :hover {
      cursor: not-allowed !important;
    }
  }
`

export const GridInput = styled(Grid)``
export const Button = styled(Grid)`
  width: 100%;
  padding-left: 60.5rem;
  padding-top: -2rem;
  padding-bottom: 1rem;
`
